import type { FunctionComponent } from 'react'
import style from './Ellipsis.module.sass'

export const Ellipsis: FunctionComponent = () => {
	const times = 3

	return (
		<div className={style.dotGroupWrapper}>
			{[...Array(times)].map((_elem, index) => (
				<div key={index} className={style.dot} />
			))}
		</div>
	)
}
